import reduxCrud from 'redux-crud';

const tripEventsReducers = reduxCrud.Map.reducersFor('tripEvents', {
  key: 'id',
});

export default tripEventsReducers;
